export const LIST_TITLE_PROPS = {
  className: 'text-style-g-em text-neutral-700 mb-4',
  skeletonProps: {
    width: 280,
  },
};

export const LIST_TITLE = 'The process takes $MIN minutes and has 3 steps:';

export const LIST = {
  etika: {
    list: {
      items: [
        'Read and agree Kanda’s T&C’s (1 minute)',
        'Provide the additional information we need to finalise your application (1 minute)',
        'Create your Etika account and submit your loan application (1 minute)',
      ],
    },
  },
  default: {
    list: {
      items: [
        'Read and agree Kanda’s T&C’s (1 minute)',
        'Complete Kanda’s application form (2 minutes)',
        'Await a decision from the lender (2 minutes)',
      ],
    },
  },
};

export const HEADER_CLASS_NAMES = {
  container: 'flex w-full flex-col mb-6',
  descriptionWrapper: 'flex flex-1 w-full flex-row items-center',
  title: 'block text-style-e text-neutral-900 mb-4',
  description: 'w-full text-14-22 text-neutral-700 mr-6',
  bold: 'text-14-22-em',
  icon: 'flex-none',
};

export const HEADER_PROPS = {
  title: {
    text: "Welcome! Let's get you approved for financing the job. It only takes a few minutes.",
    className: HEADER_CLASS_NAMES.title,
    skeletonProps: {
      count: 2,
    },
  },
  etikaTitle: {
    text: "Let's finalise your loan application with Etika Finance,  via Kanda",
    className: HEADER_CLASS_NAMES.title,
    skeletonProps: {
      count: 2,
    },
  },
  description: {
    textLine1: 'Kanda is a credit broker and loans are provided through ',
    textLine2: '. You’re applying for a loan for your purchase from ',
    textLine3:
      ", so you are in good hands. We'll help you finalise your application.",
    otherProps: {
      skeletonProps: {
        count: 4,
      },
    },
  },
  icon: {
    size: 48,
    icon: 'shield-check',
    stroke: 'purple-200',
    className: HEADER_CLASS_NAMES.icon,
  },
};

export const PROVIDERS = {
  omni: 'Omni Capital Retail Finance, part of Castle Trust Bank',
  allium: 'Tandem Bank',
  propensio: 'Propensio Finance Limited',
  etika: 'Etika Finance UK Limited',
  demo: 'Kanda Finance Limited',
};
